import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import trCommon from './locales/tr/common.json';
import trAuth from './locales/tr/auth.json';
import trProfile from './locales/tr/profile.json';
import trGames from './locales/tr/games.json';
import trSupport from './locales/tr/support.json';
import trNavigation from './locales/tr/navigation.json';

import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enProfile from './locales/en/profile.json';
import enGames from './locales/en/games.json';
import enSupport from './locales/en/support.json';
import enNavigation from './locales/en/navigation.json';

import deCommon from './locales/de/common.json';
import deAuth from './locales/de/auth.json';
import deProfile from './locales/de/profile.json';
import deGames from './locales/de/games.json';
import deSupport from './locales/de/support.json';
import deNavigation from './locales/de/navigation.json';

import ruCommon from './locales/ru/common.json';
import ruAuth from './locales/ru/auth.json';
import ruProfile from './locales/ru/profile.json';
import ruGames from './locales/ru/games.json';
import ruSupport from './locales/ru/support.json';
import ruNavigation from './locales/ru/navigation.json';

import arCommon from './locales/ar/common.json';
import arAuth from './locales/ar/auth.json';
import arProfile from './locales/ar/profile.json';
import arGames from './locales/ar/games.json';
import arSupport from './locales/ar/support.json';
import arNavigation from './locales/ar/navigation.json';

import koCommon from './locales/ko/common.json';
import koAuth from './locales/ko/auth.json';
import koProfile from './locales/ko/profile.json';
import koGames from './locales/ko/games.json';
import koSupport from './locales/ko/support.json';
import koNavigation from './locales/ko/navigation.json';

import frCommon from './locales/fr/common.json';
import frAuth from './locales/fr/auth.json';
import frProfile from './locales/fr/profile.json';
import frGames from './locales/fr/games.json';
import frSupport from './locales/fr/support.json';
import frNavigation from './locales/fr/navigation.json';

import esCommon from './locales/es/common.json';
import esAuth from './locales/es/auth.json';
import esProfile from './locales/es/profile.json';
import esGames from './locales/es/games.json';
import esSupport from './locales/es/support.json';
import esNavigation from './locales/es/navigation.json';

import plCommon from './locales/pl/common.json';
import plAuth from './locales/pl/auth.json';
import plProfile from './locales/pl/profile.json';
import plGames from './locales/pl/games.json';
import plSupport from './locales/pl/support.json';
import plNavigation from './locales/pl/navigation.json';

import zhCommon from './locales/zh/common.json';
import zhAuth from './locales/zh/auth.json';
import zhProfile from './locales/zh/profile.json';
import zhGames from './locales/zh/games.json';
import zhSupport from './locales/zh/support.json';
import zhNavigation from './locales/zh/navigation.json';

import itCommon from './locales/it/common.json';
import itAuth from './locales/it/auth.json';
import itProfile from './locales/it/profile.json';
import itGames from './locales/it/games.json';
import itSupport from './locales/it/support.json';
import itNavigation from './locales/it/navigation.json';

import azCommon from './locales/az/common.json';
import azAuth from './locales/az/auth.json';
import azProfile from './locales/az/profile.json';
import azGames from './locales/az/games.json';
import azSupport from './locales/az/support.json';
import azNavigation from './locales/az/navigation.json';

import jaCommon from './locales/ja/common.json';
import jaAuth from './locales/ja/auth.json';
import jaProfile from './locales/ja/profile.json';
import jaGames from './locales/ja/games.json';
import jaSupport from './locales/ja/support.json';
import jaNavigation from './locales/ja/navigation.json';

import ptCommon from './locales/pt/common.json';
import ptAuth from './locales/pt/auth.json';
import ptProfile from './locales/pt/profile.json';
import ptGames from './locales/pt/games.json';
import ptSupport from './locales/pt/support.json';
import ptNavigation from './locales/pt/navigation.json';

export const languages = [
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷', dir: 'ltr' },
  { code: 'en', name: 'English', flag: '🇬🇧', dir: 'ltr' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪', dir: 'ltr' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺', dir: 'ltr' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦', dir: 'rtl' },
  { code: 'ko', name: '한국어', flag: '🇰🇷', dir: 'ltr' },
  { code: 'fr', name: 'Français', flag: '🇫🇷', dir: 'ltr' },
  { code: 'es', name: 'Español', flag: '🇪🇸', dir: 'ltr' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱', dir: 'ltr' },
  { code: 'zh', name: '中文', flag: '🇨🇳', dir: 'ltr' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹', dir: 'ltr' },
  { code: 'az', name: 'Azərbaycan', flag: '🇦🇿', dir: 'ltr' },
  { code: 'ja', name: '日本語', flag: '🇯🇵', dir: 'ltr' },
  { code: 'pt', name: 'Português', flag: '🇵🇹', dir: 'ltr' },
];

const resources = {
  tr: {
    common: trCommon,
    auth: trAuth,
    profile: trProfile,
    games: trGames,
    support: trSupport,
    navigation: trNavigation,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    profile: enProfile,
    games: enGames,
    support: enSupport,
    navigation: enNavigation,
  },
  de: {
    common: deCommon,
    auth: deAuth,
    profile: deProfile,
    games: deGames,
    support: deSupport,
    navigation: deNavigation,
  },
  ru: {
    common: ruCommon,
    auth: ruAuth,
    profile: ruProfile,
    games: ruGames,
    support: ruSupport,
    navigation: ruNavigation,
  },
  ar: {
    common: arCommon,
    auth: arAuth,
    profile: arProfile,
    games: arGames,
    support: arSupport,
    navigation: arNavigation,
  },
  ko: {
    common: koCommon,
    auth: koAuth,
    profile: koProfile,
    games: koGames,
    support: koSupport,
    navigation: koNavigation,
  },
  fr: {
    common: frCommon,
    auth: frAuth,
    profile: frProfile,
    games: frGames,
    support: frSupport,
    navigation: frNavigation,
  },
  es: {
    common: esCommon,
    auth: esAuth,
    profile: esProfile,
    games: esGames,
    support: esSupport,
    navigation: esNavigation,
  },
  pl: {
    common: plCommon,
    auth: plAuth,
    profile: plProfile,
    games: plGames,
    support: plSupport,
    navigation: plNavigation,
  },
  zh: {
    common: zhCommon,
    auth: zhAuth,
    profile: zhProfile,
    games: zhGames,
    support: zhSupport,
    navigation: zhNavigation,
  },
  it: {
    common: itCommon,
    auth: itAuth,
    profile: itProfile,
    games: itGames,
    support: itSupport,
    navigation: itNavigation,
  },
  az: {
    common: azCommon,
    auth: azAuth,
    profile: azProfile,
    games: azGames,
    support: azSupport,
    navigation: azNavigation,
  },
  ja: {
    common: jaCommon,
    auth: jaAuth,
    profile: jaProfile,
    games: jaGames,
    support: jaSupport,
    navigation: jaNavigation,
  },
  pt: {
    common: ptCommon,
    auth: ptAuth,
    profile: ptProfile,
    games: ptGames,
    support: ptSupport,
    navigation: ptNavigation,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'tr',
    defaultNS: 'common',
    ns: ['common', 'auth', 'profile', 'games', 'support', 'navigation'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    react: {
      useSuspense: false,
    },
  });

export const changeLanguage = (lang: string) => {
  i18n.changeLanguage(lang);
  const langConfig = languages.find(l => l.code === lang);
  if (langConfig) {
    document.documentElement.dir = langConfig.dir;
    document.documentElement.lang = lang;
  }
};

export default i18n;
